<template>
    <div class="ViewForm">
        <WText
            tag="label"
            typo="label"
            :size="14"
        >
            {{ $t('entities.views.create.name.label') }}
        </WText>
        <WFieldError
            :validator="$v.label"
            :messages="{ maxLength: $t('entities.views.create.name.lengthError') }"
            :label="$t('entities.views.create.name.label')"
            #default="{ errorMessage, listeners }"
            class="mb-2"
        >
            <WInput
                v-model="label"
                :error="errorMessage"
                :placeholder="$t('entities.views.create.name.placeholder')"
                :disabled="loading"
                name="label"
                type="text"
                v-on="listeners"
                @keyup.enter="handleSubmit"
            />
        </WFieldError>
        <div class="flex row-right-center">
            <WButton
                class="mr-1"
                :outline="true"
                color="accent-blue"
                :disabled="loading"
                @click="$emit('onCancel')"
            >
                {{ $t('actions.cancel') }}
            </WButton>
            <WButton
                :loading="loading"
                :disabled="loading"
                @click="handleSubmit"
            >
                {{ $t('actions.confirm') }}
            </WButton>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
    name: 'ViewForm',
    mixins: [validationMixin],
    props: {
        value: VueTypes.string,
        loading: VueTypes.bool.def(false),
    },
    data () {
        return {
            label: this.value || '',
        }
    },
    validations () {
        return {
            label: { required, maxLength: maxLength(100) },
        }
    },
    methods: {
        handleSubmit () {
            this.$v.$touch()
            if (!this.$v.$invalid) this.$emit('onSubmit', this.label)
        },
    },
}
</script>
